var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgEHeatingTabsPump = function SvgEHeatingTabsPump(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 684 480"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 684,
    height: 480,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 626,
    cy: 223,
    r: 14,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626,210c7.17,0,13,5.83,13,13s-5.83,13-13,13-13-5.83-13-13,5.83-13,13-13M626,209c-7.73,0-14,6.27-14,14s6.27,14,14,14,14-6.27,14-14-6.27-14-14-14h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M612.71,223.5c-.13,0-.25-.05-.35-.14-.2-.19-.2-.51,0-.71l13.15-13.5c.19-.2.51-.2.71,0,.2.19.2.51,0,.71l-13.15,13.5c-.1.1-.23.15-.36.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.86,237c-.13,0-.26-.05-.36-.15l-13.15-13.5c-.19-.2-.19-.51,0-.71.2-.19.51-.19.71,0l13.15,13.5c.19.2.19.51,0,.71-.1.09-.22.14-.35.14Z"
  })))));
};
export default SvgEHeatingTabsPump;